<template>
  <div class="all_part">
    <div class="head">
      <div class="back" @click="back">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="30px" />
      </div>
      <div class="titleName">
        <span>非标物料主档</span>
      </div>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top" >
          <div>
            <div style="margin-bottom: 10px">
              <el-select v-model="ChanPinDaLei_choice" placeholder="请选择产品大类" style="width: 290px">
                <el-option
                    v-for="item in ChanPinDaLei_Select"
                    :key="item.value"
                    :label="item.category"
                    :value="item.id"
                    @click="this.serchChanPinXiaoLei()"
                >
                </el-option>
              </el-select>
            </div >
            <div style="margin-bottom: 10px">
              <el-select v-model="ChanPinXiaoLei_choice" placeholder="请选择产品小类" style="width: 290px">
                <el-option
                    v-for="item in ChanPinXiaoLei_Select"
                    :key="item.value"
                    :label="item.title"
                    :value="item.id"

                >
                </el-option>
              </el-select>
            </div>
            <div style="margin-bottom: 10px">
              <el-select v-model="CaiZhi_choice" placeholder="请选择材质" style="width: 290px">
                <el-option
                    v-for="item in CaiZhi_select"
                    :key="item.value"
                    :label="item.title"
                    :value="item.title"

                >
                </el-option>
              </el-select>
            </div>
            <div style="margin-bottom: 10px">
              <el-input
                  v-model="newItemNo"
                  placeholder="请输入新料号"
                  style="width: 290px"
              ></el-input>
            </div>
            <div style="margin-bottom: 10px">
              <el-input
                  v-model="oldMaterialNo"
                  placeholder="请输入旧料号"
                  style="width: 290px"
              ></el-input>
            </div>
            <div>
              <el-input
                  v-model="inquiry_no"
                  placeholder="请输入询价单号"
                  style="width: 290px"
              ></el-input>
            </div>
          </div>

        </div>
        <div class="submit_button">
          <div class="search_button">
            <el-button type="primary" @click="serchChanPin" style="height: 48px; width: 244px;background: #96c8fb;border-radius: 25px"
            >搜索
            </el-button
            >
          </div>
          <div class="all_second_button">
            <div class="second_button" @click="clearInput">
              <el-button plain type="primary" style="width: 92px; height: 48px"
              >重置
              </el-button
              >
            </div>



          </div>
        </div>
      </div>

    </div>
    <div class="">
      <div v-for="(item, i) in tableData" class="list_div">
        <div class="Key">
            <span>平台产品编号</span>
            <span>{{ item.product_number}}</span>
          </div>
        <div class="Key">
          <span>新料号</span>
          <span>{{ item.newItemNo}}</span>
        </div>
        <div class="Key">
          <span>旧料号</span>
          <span>{{ item.oldMaterialNo}}</span>
        </div>
        <div class="Key">
          <span>产品大类</span>
          <span>{{ item.category}}</span>
        </div>
        <div class="Key">
          <span>询价单号</span>
          <span>{{ item.inquiry_no}}</span>
        </div>
        <div class="Key">
          <span>折扣类别</span>
          <span>{{ item.discount_category}}</span>
        </div>
        <div class="Key">
          <span>产品类别</span>
          <span>{{ item.product_category}}</span>
        </div>
        <div class="Key">
          <span>产品小类</span>
          <span>{{ item.product_category_small}}</span>
        </div>
        <div class="Key">
          <span>材质</span>
          <span>{{ item.material}}</span>
        </div>
        <div class="Key">
          <span>尺寸描述</span>
          <span>{{ item.dimension_description}}</span>
        </div>
        <div class="Key">
          <span>材质描述</span>
          <span>{{ item.material_description}}</span>
        </div>
        <div class="Key">
          <span>描述</span>
          <span>{{ item.describe}}</span>
        </div>
        <div class="Key">
          <span>尺寸标准代码</span>
          <span>{{ item.standard_code}}</span>
        </div>
        <div class="Key">
          <span>标准</span>
          <span>{{ item.standard}}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "../components/publics";

export default {
  data() {
    return {
      PanDuanShou:false,
      tableData: [],
      newItemNo: "",//新料号
      oldMaterialNo: "",//旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "",//产品线径
      ChanPinXiaoLei_choice: "",//产品小类选择
      CaiZhi_choice: "",//材质选择   //material
      BiaoZhun_Choice: "",//标准选择
      YingDu_Choice: "",//硬度选择
      standard_code: "",//标准代码
      inquiry_no: "",//询价单号
      CaiLiaoXinXi_Code_Choice: "",//材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "",//颜色选择
      ChanPinDaLei_Select: [],  // 产品大类下拉框
      ChanPinXiaoLei_Select: [],//产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [],//标准下拉框
      YingDu_Select: [],//硬度下拉框
      CaiLiaoXinXi_Code_Select: [],//材料信息下拉框
      YanSe_Select: [],//颜色下拉框
      page: "",

    };
  },
  mounted() {
    this.serchChanPinDaLei();
    this.serchBiaoZhun();
    this.serchYingDu();
    this.serchCaiLiaoXinxi();
    this.serchYanSe();
  },
  methods:{
    back(){
      this.$router.back()
    },
    clearInput(){
      this. newItemNo="";//新料号
      this. oldMaterialNo= "";//旧料号
      this. internal_meridian= ""; // 产品内径
      this. wire_diameter= "";//产品线径
      this. ChanPinXiaoLei_choice= "";//产品小类选择
      this. CaiZhi_choice= "";//材质选择   //material
      this. BiaoZhun_Choice= "";//标准选择
      this. YingDu_Choice= "";//硬度选择
      this. standard_code= "";//标准代码
      this. inquiry_no= "";//询价单号
      this. CaiLiaoXinXi_Code_Choice= "";//材料信息选择
      this. ChanPinDaLei_choice= ""; // 产品大类选择
      this. YanSe_Choice= "";//颜色选择

    },
    inputShow(){
      if (this.PanDuanShou ){
        this.PanDuanShou = !this.PanDuanShou
      }else {
        this.PanDuanShou = !this.PanDuanShou
      }
    },
    reflash(val) {
      console.log(1)
      console.log( this.page+1)
      this.page = val
      this.serchChanPin()
    },
    serchBiaoZhun() {
      this.axios
          .get(httpUrl + `/api/index/standard`)
          .then((response) => {
            if (response.data.code == 200) {
              this.BiaoZhun_Select = response.data.data
              console.log(this.tableData.data)

            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
          .get(httpUrl + `/api/index/hardness`)
          .then((response) => {
            if (response.data.code == 200) {
              this.YingDu_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi() {
      this.axios
          .get(httpUrl + `/api/index/material_number`)
          .then((response) => {
            if (response.data.code == 200) {
              this.CaiLiaoXinXi_Code_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchYanSe() {
      this.axios
          .get(httpUrl + `/api/index/colorOffer`)
          .then((response) => {
            if (response.data.code == 200) {
              this.YanSe_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
          .get(httpUrl + `/api/index/non_standard_material?supplier_id=${this.ChanPinDaLei_choice}&non_standard_category_id=${this.ChanPinXiaoLei_choice}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.CaiZhi_select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
          .get(httpUrl + `/api/index/non_standard_category?supplier_id=${val}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.ChanPinXiaoLei_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
          .get(httpUrl + `/api/index/non_category`)
          .then((response) => {
            if (response.data.code == 200) {
              this.ChanPinDaLei_Select = response.data.data
              console.log(this.tableData.data)

            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem('user'));
      let selectID = suser_id.id;
      console.log(selectID)
      this.axios
          .get(httpUrl + `/api/index/non_standard?newItemNo=${this.newItemNo}&oldMaterialNo=${this.oldMaterialNo}&material=${this.CaiZhi_choice}&category_small=${this.ChanPinXiaoLei_choice}&category_big=${this.ChanPinDaLei_choice}&inquiry_no=${this.inquiry_no}&page=${this.page}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.total = response.data.data.total
              this.tableData = response.data.data.data;
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    }
  }
};
</script>

<style>

</style>

<style scoped>
.all_part {
  height: 100vh;
}

.head {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  align-items: center;
  height: 45px;
  background-color: #409eff;
  border-bottom: rgba(55, 55, 55, 0.2) 2px solid;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  background-color: #409eff;
  height: 32%;

}

.all_input_top {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.Key {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 12px;
}

.serch {
  width: 60%;
}

.list_div {
  height: 400px;
  padding:20px 30px;
  margin-top: 20px;
  background-image: url("../assets/未标题-1.png");
  background-size: 100% 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}
</style>